"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _form = require("@clayui/form");
var _loadingIndicator = _interopRequireDefault(require("@clayui/loading-indicator"));
var _react = _interopRequireDefault(require("react"));
var _Context = require("./Context");
var _excluded = ["children"],
  _excluded2 = ["className", "component"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var LoadingIndicatorMarkup = function LoadingIndicatorMarkup(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupInsetItem, _extends({}, otherProps, {
    after: true
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "inline-item inline-item-middle"
  }, children));
};
var ClayAutocompleteLoadingIndicator = function ClayAutocompleteLoadingIndicator(_ref2) {
  var className = _ref2.className,
    _ref2$component = _ref2.component,
    Component = _ref2$component === void 0 ? LoadingIndicatorMarkup : _ref2$component,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var _React$useContext = _react.default.useContext(_Context.LegacyContext),
    onLoadingChange = _React$useContext.onLoadingChange;
  _react.default.useEffect(function () {
    onLoadingChange(true);
    return function () {
      onLoadingChange(false);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, otherProps, {
    className: className
  }), /*#__PURE__*/_react.default.createElement(_loadingIndicator.default, {
    small: true
  }));
};
var _default = exports.default = ClayAutocompleteLoadingIndicator;